export default __webpack_public_path__ + "static/home-tab-payment-33ac86addba727fc6b7b9c21b10a12dd.svg";